// extracted by mini-css-extract-plugin
export var progressBar = "_nf-0";
export var progressBarInner = "_nf-1";